import React from 'react';

import { useContextHandling } from 'common/hooks/useContextHandling';

import { GlobalWidgetConfig } from './global-widget-config-types';
import { DEFAULT_WIDGET_LAYOUT_SETTINGS } from './widget-layout-config';

export const GlobalWidgetConfigContext = React.createContext<GlobalWidgetConfig | null>(null);

export const useGlobalWidgetConfig = () => {
  return useContextHandling(GlobalWidgetConfigContext, fallbackState);
};

const fallbackState: GlobalWidgetConfig = {
  layoutSettings: DEFAULT_WIDGET_LAYOUT_SETTINGS,
};
